import { environment } from '../environments/environment';
export const authConfig: any = {
    authority: `${environment.authConfig.authApi}/connect/token`,
    client_id: environment.authConfig.clientId,
    // client_secret: environment.authConfig.client_secret,
    grant_type: 'password',
    scope: environment.authConfig.scope,
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/auth.config.ts